import request from "library/v1/request";

export function authenticate(data) {
  return request({
    url: `/session/token`,
    method: 'post',
    data: data,
    params: {
      skipAuth: true
    }
  });
}

export function redirectToken(data) {
  return request({
    url: `/session/redirect_token`,
    method: 'post',
    data: data,
    params: {
      skipAuth: true
    }
  });
}

export function refreshToken(data) {
  return request({
    url: `/session/refresh_token`,
    method: 'post',
    data: data,
    params: {
      skipAuth: true
    }
  });
}
